module.exports = __webpack_public_path__ + "img/sscalculator.e518950a.svg";